import React from 'react';
import { TeamChatTypes } from '@frontend/api-team-chat';
import { SkeletonLoader } from '@frontend/design-system';
import { useGetMentionedUser } from '../../../hooks/use-get-mention-user';
import { getUserFullName } from '../../../utils';
import { MentionTag } from './mention-tag';

interface MentionRendererProps {
  mentionText: string;
  users: TeamChatTypes.User[];
  currentUser?: TeamChatTypes.User;
  index: number;
}

/**
 * Renders a mention tag or fallback text
 */
export const MentionRenderer: React.FC<MentionRendererProps> = ({ mentionText, users, currentUser, index }) => {
  const { data: user, isError, isLoading } = useGetMentionedUser({ users, mentionText });

  if (isLoading) {
    return (
      <span key={`mention-loading-${mentionText}-${index}`} className='mention-loading'>
        <SkeletonLoader width={60} height={16} animation='shimmer' />
      </span>
    );
  }

  if (!user || isError) {
    return <React.Fragment key={`mention-fallback-${mentionText}-${index}`}>{mentionText}</React.Fragment>;
  }

  const isSelf = user.userID === currentUser?.userID;

  return (
    <MentionTag
      key={`mention-${mentionText}-${index}`}
      label={`@${getUserFullName(user.firstName, user.lastName)}`}
      isSelf={isSelf}
    />
  );
};
